<template>
  <div v-if="breadcrumb" class="breadcrumb-container">
    <fin-breadcrumb separator="/">
      <fin-breadcrumb-item>{{ breadcrumb }}</fin-breadcrumb-item>
    </fin-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'AppBreadcrumb',
  computed: {
    breadcrumb() {
      return this.$route.meta.title;
    }
  }
};
</script>

<style lang="scss" scoped>
.breadcrumb-container {
  height: 50px;
  display: flex;
  align-items: center;
  .fin-breadcrumb {
    font-size: 16px;
    color: rgba(51,51,51,1);
    font-family: PingFangSC;
    font-weight: 600;
    ::v-deep.fin-breadcrumb__item {
      .is-link {
      }
      .fin-breadcrumb__separator {
      }
      &:last-child {
        .fin-breadcrumb__inner {
        }
      }
    }
  }
}
</style>
